import {
  Stethoscope,
  ShieldCheck,
  Activity,
  Droplets,
  HeartPulse,
  Gauge,
  Timer,
  Leaf,
  Users,
  Award,
  Waves,
  HeartHandshake,
  Thermometer,
  Wind,
  Zap,
  Utensils,
  Brain,
  Bed,
  ClipboardCheck,
  Syringe,
  Share2,
} from "lucide-react";

const MAP = {
  Stethoscope,
  ShieldCheck,
  Activity,
  Droplets,
  HeartPulse,
  ScanHeart: Waves,
  Gauge,
  Timer,
  Leaf,
  Users,
  Award,
  HeartHandshake,
  Thermometer,
  Wind,
  Zap,
  Utensils,
  Brain,
  Bed,
  ClipboardCheck,
  Syringe,
  Share2,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || HeartPulse;
  return <Cmp {...props} />;
}
